export default "__VITE_ASSET__BJme1oPL__"